import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class RepositoryColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Repository
  declare readonly dataType: typeof MemexColumnDataType.Repository
  declare readonly userDefined: false
}
